export const runOnceOnElement = (el, fn, ...args) => {
    if (el.data('larasnap-initialized') !== true) {
        fn(el, ...args);
        el.data('larasnap-initialized', true);
    }
};
